export const heroSlides = [
  {
    id: "m08",
    kicker: "本期焦点 · 城市夜行",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20night%20shot%20of%20an%20empty%20Tokyo%20backstreet%20with%20red%20neon%20reflections%20on%20wet%20asphalt%20and%20soft%20rain%2C%20moody%20charcoal%20and%20crimson%20tones%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=jpf-hero-01&orientation=landscape",
  },
  {
    id: "m11",
    kicker: "新片上架 · 影院告别",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20an%20empty%20old%20single%20screen%20cinema%20with%20deep%20red%20velvet%20seats%20and%20a%20faint%20projector%20beam%2C%20dusty%20warm%20light%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=jpf-hero-02&orientation=landscape",
  },
  {
    id: "m02",
    kicker: "编辑推荐 · 梅雨之后",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20a%20rain%20soaked%20stone%20alley%20in%20Kyoto%20at%20dusk%20with%20wet%20reflections%20and%20a%20single%20warm%20lantern%2C%20muted%20crimson%20and%20charcoal%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=jpf-hero-03&orientation=landscape",
  },
  {
    id: "m21",
    kicker: "年度口碑 · 家庭叙事",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20a%20small%20old%20Japanese%20diner%20kitchen%20at%20night%20with%20rising%20steam%20and%20warm%20hanging%20lamp%2C%20deep%20amber%20and%20shadow%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=jpf-hero-04&orientation=landscape",
  },
  {
    id: "m24",
    kicker: "冬季特集 · 雪夜静默",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20snow%20falling%20outside%20a%20ryokan%20window%20with%20warm%20paper%20lamp%20light%20inside%2C%20cold%20blue%20grey%20and%20amber%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=jpf-hero-05&orientation=landscape",
  },
];